export const localStoragePush = (value: string, key: string) => {
  const returnToArray = localStorageRead(key);
  returnToArray.push(value);
  localStorage.setItem(key, JSON.stringify(returnToArray));
}

export const localStorageRead = (key: string): string[] =>
  JSON.parse(localStorage.getItem(key) ?? '[]');
